import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import Link from 'next/link';
import clsx from 'clsx';

//hooks
import useSubscription from '@/utils/hooks/swr/pricing/useSubscription';

//lib
import { CHANGE_YOUR_PLAN } from '@/lib/settings/subscriptionInvoices/steps';

//routes
import { SUBSCRIPTION_INVOICES } from '@/routes/privateRoutes';

import Tooltip from '@/components/base/Tooltip';

type KpiDataRetentionProps = { isDisplayed?: boolean; alignText?: 'center' | 'left' };

export function KpiDataRetention({ isDisplayed, alignText = 'center' }: KpiDataRetentionProps) {
    const { t } = useTranslation('analytics');
    const { subscription } = useSubscription();

    if (!subscription || !isDisplayed) {
        return null;
    }

    return (
        <Tooltip
            content={
                <Trans
                    i18nKey={`analytics:data_retention_disclaimer_plan_${subscription.product_key}`}
                    components={{
                        link: (
                            <Link
                                href={{
                                    pathname: SUBSCRIPTION_INVOICES,
                                    query: { step: CHANGE_YOUR_PLAN }
                                }}
                                className="underline"
                            />
                        )
                    }}
                />
            }
            placement="top"
            interactive>
            <span
                className={clsx(
                    '!mt-2 block font-GMedium text-xs text-icoGray-400 dark:text-icoDarkMode-wolf',
                    {
                        'text-center': alignText === 'center',
                        'text-left': alignText === 'left'
                    }
                )}
                data-testid="data-retention-disclaimer">
                {t('data_retention_disclaimer')}
            </span>
        </Tooltip>
    );
}
